import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import React, { useEffect, useState } from "react";
import { getValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NoAccessPage from "@components/common/NoAccess";

// import "entypo";

import "./index.scss";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { useParams } from "react-router-dom";
import { ctcReimbursementView } from "@services/dashboard.service";

function ReimbursementView(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  const params = useParams();

  
  const navigate = useNavigate();

  useEffect(() => {
    getReimbursementViewData();
  }, []);
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [reimbursementViewData, setReimbursementViewData] = useState<any>([]);
  const [applicationDetails, setApplicationDetails] = useState<any>({});
  const [formData, setFormData] = useState<any>({});
  const [formDataKeys, setFormDataKeys] = useState<string[]>([]);
  const [reimbursementColumns, setReimbursementColumns] = useState<any[]>([]);
  const [applicationDetailsKeys, setApplicationDetailsKeys] = useState<string[]>([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  const getReimbursementViewData = async () => {
    try {
      const token = localStorage.getItem('stohrmToken');
      let payload = {
        token: token,
        register_id: params.register_id,
      };
      const resp = await ctcReimbursementView(payload);
      if(resp && resp.statusCode === 200) {
        // Create an array with the reimbursement details for the table
        setReimbursementViewData([resp.data.reimbursement_details]);
        setApplicationDetails(resp.data.application_details);
        setFormData(resp.data.form_data);
        
        // Extract keys from form_data excluding 'total'
        const keys = Object.keys(resp.data.form_data).filter(key => key !== 'total');
        setFormDataKeys(keys);
        
        // Generate dynamic columns for reimbursement details
        if (resp.data.reimbursement_details) {
          const dynamicColumns = Object.keys(resp.data.reimbursement_details).map(key => {
            // Format the header text by replacing underscores with spaces and capitalizing
            const headerText = key.split('_')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
            
            // Determine appropriate width based on column type
            let width = 150;
            if (key === 'details') width = 300;
            else if (['applied_amount', 'approved_amount', 'rejected_amount'].includes(key)) width = 120;
            else if (key === 'status') width = 200;
            
            return {
              Header: headerText,
              accessor: key,
              style: { "white-space": "unset", overflow: "hidden" },
              width: width,
            };
          });
          
          setReimbursementColumns(dynamicColumns);
        }
        
        // Extract application details keys excluding 'documents'
        if (resp.data.application_details) {
          const appDetailsKeys = Object.keys(resp.data.application_details)
            .filter(key => key !== 'documents');
          setApplicationDetailsKeys(appDetailsKeys);
        }
        
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching reimbursement data:", error);
    }
  };
  
  // const reimbursementColumns = React.useMemo(
  //   () => [
  //     {
  //       Header: "AppIn No",
  //       accessor: "appin_no",
  //       style: { "white-space": "unset", overflow: "hidden" },
  //       width: 100,
  //     },
  //     {
  //       Header: "Reimbursement Type",
  //       accessor: "reimbursement_type",
  //       style: { "white-space": "unset" },
  //       width: 250,
  //     },
  //     {
  //       Header: "Application Date",
  //       accessor: "application_date",
  //       style: { "white-space": "unset" },
  //       width: 150,
  //     },
  //     {
  //       Header: "Details",
  //       accessor: "details",
  //       style: { "white-space": "unset" },
  //       width: 300,
  //     },
  //     {
  //       Header: "Applied",
  //       accessor: "applied",
  //       style: { "white-space": "unset" },
  //       width: 120,
  //     },
  //     {
  //       Header: "Approved",
  //       accessor: "approved",
  //       style: { "white-space": "unset" },
  //       width: 120,
  //     },
  //     {
  //       Header: "Rejected",
  //       accessor: "rejected",
  //       style: { "white-space": "unset" },
  //       width: 120,
  //     },
  //     {
  //       Header: "Status",
  //       accessor: "status",
  //       style: { "white-space": "unset" },
  //       width: 200,
  //     },
  //   ],
  //   []
  // );

  const reimbursementData = React.useMemo(
    () => [
      {
        appin_no: 24,
        reimbursement_type: "Communication Expenses",
        application_date: "22/01/2025",
        details:
          "Lorem ipsum dolor sit amet consectetur adipiscing elit. Labore magni at doloribus nemo praesentium similique neque, nulla blanditiis commodi sapiente deserunt, sequi optio! Doloremque molestiae esse a beatae, placeat non?",
        applied: "1,000",
        approved: 0,
        rejected: 0,
        status: "Waiting for Approval",
      },
    ],
    []
  );

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      reimbursementData.length > 0
        ? reimbursementData.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {
    navigate(`/edit-user/${getValue(obj, `original.id`, "")}`);
  };

  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };

  const formDetailsColumns = React.useMemo(
    () => [
      {
        Header: "Service Provider Name",
        accessor: "service_provider",
        style: { "white-space": "unset", overflow: "hidden" },
        width: 200,
      },
      {
        Header: "Mobile/Telephone Number",
        accessor: "mobile_number",
        style: { "white-space": "unset" },
        width: 200,
      },
      {
        Header: "Bill Number",
        accessor: "bill_number",
        style: { "white-space": "unset" },
        width: 200,
      },
      {
        Header: "Bill Date",
        accessor: "bill_date",
        style: { "white-space": "unset" },
        width: 150,
      },
      {
        Header: "Billing Period",
        accessor: "billing_period",
        style: { "white-space": "unset" },
        width: 150,
      },
      {
        Header: "Amount",
        accessor: "amount",
        style: { "white-space": "unset" },
        width: 100,
      },
    ],
    []
  );

  // const formDetailsData = React.useMemo(
  //     () => [
  //         {
  //             service_provider: "Shubham",
  //             mobile_number: "651998h",
  //             bill_number: "BILL49695A",
  //             bill_date: "01/01/2025",
  //             billing_period: "May - 2024",
  //             amount: "1000",
  //         },
  //     ],
  //     []
  // );

  // const totalAmount = "1,000";

  const formDetailsData = [
    {
      service_provider: "Shubham",
      mobile_number: "651998h",
      bill_number: "BILL49695A",
      bill_date: "01/01/2025",
      billing_period: "May - 2024",
      amount: 1000,
    },
  ];

  // Calculate Total Amount
  const totalAmount = formData.total || 0;

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes("dashboard") ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <h4 className="dashbaord-wrapper__header-title">
              Reimbursement View
            </h4>
          </div>
          <div className="reimbursement-dashbaord-wrapper_section_container reimbursement-view-wrapper_section_container">
            {/* {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : ( */}
            <>
              <div className="card bg-light mb-3">
                <div className="card-header">Reimbursement Details</div>

                <div className="card-body bg-white" style={{borderBottomLeftRadius: "4px", borderBottomRightRadius: "4px"}}>
                  {reimbursementColumns.length > 0 && (
                    <ScrollableReactTable
                      columns={reimbursementColumns}
                      data={reimbursementViewData}
                      getTableState={getTableState}
                      rowClick={rowClick}
                      checkboxlogo
                      selectedIDs={selectedIDs}
                      getTrProps={getTrProps}
                    />
                  )}
                </div>
              </div>

              <div className="d-flex gap-3">
                <div style={{ width: "70%", minWidth: "70%" }}>
                  <div className="card bg-light">
                    <div className="card-header">Form Details</div>

                    <div className="card-body bg-white p-2 custom-table" style={{borderBottomLeftRadius: "4px", borderBottomRightRadius: "4px"}}>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            {formDataKeys.map((key, index) => (
                              <th key={index} style={{ textTransform: 'capitalize' }}>
                                {key.replace(/_/g, ' ')}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            {formDataKeys.map((key, index) => (
                              <td key={index}>{formData[key]}</td>
                            ))}
                          </tr>
                          {/* Total Row */}
                          <tr style={{ fontWeight: "bold", background: "#f4f4f4" }}>
                            <td colSpan={formDataKeys.length - 1} style={{ textAlign: "right" }}>
                              Total:
                            </td>
                            <td>{totalAmount}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="card bg-light">
                  <div className="card-header">Application Details</div>

                  <div className="card-body bg-white custom-table" style={{borderBottomLeftRadius: "4px", borderBottomRightRadius: "4px"}}>
                    <table className="table table-bordered">
                      <tbody>
                        {applicationDetailsKeys.map((key) => (
                          <tr key={key}>
                            <td style={{ textTransform: 'capitalize' }}>{key.replace(/_/g, ' ')}</td>
                            <td>{applicationDetails[key] || '-'}</td>
                          </tr>
                        ))}
                        
                        {/* Documents section - always show this separately */}
                        <tr>
                          <td>Document</td>
                          <td>
                            {applicationDetails.documents && applicationDetails.documents.length > 0 ? (
                              applicationDetails.documents.map((doc: any, index: number) => (
                                <div key={index}>
                                  <a href={atob(doc.document_link)} target="_blank" rel="noopener noreferrer">
                                    Document {index + 1}
                                  </a>
                                </div>
                              ))
                            ) : (
                              '-'
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>File password (if any)</td>
                          <td>
                            {applicationDetails.documents && applicationDetails.documents.length > 0 ? (
                              applicationDetails.documents.map((doc: any, index: number) => (
                                <div key={index}>{doc.file_password || '-'}</div>
                              ))
                            ) : (
                              '-'
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
            {/* )} */}
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

export default ReimbursementView;
